export const SELECT_CLINIC = "selectclinic";
export const ORGANISATION = "organisation";
export const MUNICIPALITY = "municipality";
export const RESIDENCE = "residence";

export const CLINIC = "clinics";


export const SILENT_RENEW = "silentRenew";